import axios from "axios";
import buildUrl from 'build-url-ts';
import { CreateCustomFieldRequest, CustomField, UpdateCustomFieldRequest } from "src/types/settings/customFields";

const BASE_URL = process.env.REACT_APP_API_URL;
const customFieldApi = `${BASE_URL}/api/2.0/custom_fields`;

export const customFieldsApi = {
  fetchCustomFields: async (): Promise<CustomField[]> => {
    const url = buildUrl(customFieldApi);
    const response = await axios.get(url);
    return response.data;
  },

  createCustomField: async (data: CreateCustomFieldRequest): Promise<CustomField[]> => {
    const url = buildUrl(customFieldApi);
    const response = await axios.post(url, data);
    return response.data;
  },

  updateCustomField: async (
    id: string,
    data: UpdateCustomFieldRequest
  ): Promise<CustomField[]> => {
    const url = buildUrl(`${customFieldApi}/${id}`);
    const response = await axios.put(url, data);
    return response.data;
  },

  deleteCustomField: async (id: string): Promise<CustomField[]> => {
    const url = buildUrl(`${customFieldApi}/${id}`);
    const response = await axios.delete(url);
    return response.data;
  },

  orderCustomFields: async (id: string[]): Promise<CustomField[]> => {
    const url = buildUrl(`${customFieldApi}/order`);
    const response = await axios.put(url, id);
    return response.data;
  }
};